import { render, staticRenderFns } from "./OthersHoney.vue?vue&type=template&id=a7c63028&scoped=true&"
import script from "./OthersHoney.vue?vue&type=script&lang=js&"
export * from "./OthersHoney.vue?vue&type=script&lang=js&"
import style0 from "./OthersHoney.vue?vue&type=style&index=0&id=a7c63028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c63028",
  null
  
)

export default component.exports